import { Modal, Box, Typography, Link } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../../components/custom-dropdown/CustomDropdown";
import { NoShowAppointmentCardIcon } from "../../components/icon-components/NoShowAppointmentCardIcon";
import styles from "./NoShowAppointmentCard.module.scss";
import CustomButton from "../../components/v2/custom-button/CustomButton";

interface NoShowAppointmentCardProps {
  modalOpen: boolean;
  onCloseModal: () => void;
  handleConfirmNoShow: (reasonId: number) => void;
  handleSkipNoShow: () => void;
  noShowReasons: { label: string; value: number }[];
  patientNoShowMessage: string;
}

const NoShowAppointmentCard: React.FC<NoShowAppointmentCardProps> = ({
  modalOpen,
  onCloseModal,
  handleConfirmNoShow,
  handleSkipNoShow,
  noShowReasons,
  patientNoShowMessage,
}) => {
  const { t } = useTranslation();
  const [selectedReason, setSelectedReason] = useState<number>(0);

  useEffect(() => {
    if (!modalOpen) {
      setSelectedReason(0);
    }
  }, [modalOpen]);

  const handleDropdownChange = (value: string | number) => {
    setSelectedReason(typeof value === "number" ? value : parseInt(value, 10));
  };

  const handleConfirmReason = () => {
    if (selectedReason !== 0) {
      handleConfirmNoShow(selectedReason);
    }
  };

  return (
    <Modal
      open={modalOpen}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onCloseModal();
      }}
    >
      <Box className={styles.modalContainer}>
        <Box className={styles.header}></Box>
        <Box className={styles.icon}>
          <NoShowAppointmentCardIcon />
        </Box>

        <Box className={styles.body}>
          <Box className={styles.titleWrapper}>
            <Typography
              variant="h4"
              className={styles.title}
            >
              {t("noShowAppointment.weHopeEverythingIsOk")}
            </Typography>
            <Box
              mb={"2rem"}
              className={styles.htmlContent}
              fontSize={"16px"}
              dangerouslySetInnerHTML={{ __html: patientNoShowMessage }}
            ></Box>
          </Box>

          <Box className={styles.dropdownWrapper}>
            <CustomDropdown
              placeholder={t("select")}
              inputFormTitle={t("noShowAppointment.dropDownList")}
              value={selectedReason}
              changeTrigger={handleDropdownChange}
              options={noShowReasons}
            />
          </Box>

          <Box className={styles.buttonGroup}>
            <CustomButton
              variant="contained"
              text={t("noShowAppointment.submitButton")}
              onClick={handleConfirmReason}
              disabled={selectedReason === 0}
              sx={{ minWidth: "115px", borderRadius: "24px" }}
            />
            <Link
              onClick={handleSkipNoShow}
              sx={{ cursor: "pointer" }}
            >
              {t("noShowAppointment.skipButton")}
            </Link>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default NoShowAppointmentCard;
